import DuckEntity from './DuckEntity'

const entity = new DuckEntity('userJobs');

export default entity.reducer;
export {entity};
